/**
 * Encodes a JavaScript value to a JSON string.
 * Supports optional indentation for pretty-printing.
 *
 * @param data - JavaScript value to encode
 * @param indent - Optional number of spaces for indentation (null for compact)
 * @returns JSON string representation
 *
 * @example
 * ```ts
 * import { JSONEncode } from "@pdfking/tfunc"
 *
 * const obj = { name: "John", age: 30 }
 * const compact = JSONEncode(obj)
 * // '{"name":"John","age":30}'
 *
 * const pretty = JSONEncode(obj, 2)
 * // '{
 * //   "name": "John",
 * //   "age": 30
 * // }'
 * ```
 */
export const JSONEncode = (data: any, indent: null | number = null) =>
  JSON.stringify(data, null, indent ?? undefined)
